* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

:host([data-is-visible]) {
  display: block;
}

.wrapper {
  padding: 2px;
}

.form-wrapper {
  min-width: 500px;
  max-width: 700px;
  width: 100%;
  height: auto;
}

.container {
  width: 100%;
  display: flex;
  flex-direction: row;

  .label {
    width: 450px;
  }

  .value {
    align-content: center;
    min-width: fit-content;
  }
}

.form-section {
  #last-scan-date-label,
  #next-scan-label {
    margin-top: 15px;
    margin-bottom: 10px;
  }

  max-width: 700px;
  width: 100%;
  height: auto;
  display: flex;
  margin-top: var(--spacer);
  align-items: flex-start;
  flex-direction: column;
  &#recurrence-weekly-container,
  &#recurrence-monthly-container {
    margin-top: 0;
  }

  #monthly-frequency-form-field {
    margin-right: var(--spacer);
  }

  .details-container {
    padding: 0 calc(var(--spacer) + 2px) 0 calc(var(--spacer) + 2px);
    border-left: 6px solid var(--blue-layout-200-disabled);
    margin-top: calc(var(--spacer) + 2px);
  }

  .flex-group {
    display: flex;
    align-items: flex-start;
  }

  gz-form-field {
    margin-bottom: var(--spacer);
    &#between-start-form-field,
    &#between-end-form-field,
    &#monthly-frequency-form-field,
    &#monthly-frequency-day-form-field,
    &#monthly-frequency-day-number-form-field,
    &#weekly-on-form-field {
      margin-bottom: 0;
    }

    &#recurrence-form-field {
      gz-dropdown {
        margin-left: calc(var(--spacer) * 2);
      }
    }

    .flex-group {
      align-items: center;
    }
  }

  #start-time-label {
    min-width: 250px;
    text-align: left !important;
    margin-right: 0 !important;

    &:after {
      content: ':';
      padding-left: calc(var(--spacer) - 6px);
    }
  }

  #start-time-labeled-content {
    gz-form-field {
      margin-right: var(--spacer);
    }

    gz-text {
      max-width: 50px;
      min-height: 32px;
      margin-right: var(--spacer);
      display: flex;
      align-items: center;
    }
  }
}
